// Vardiya yönetimi ve vardiya puantajı tek tabloda birleştiği için durumlar da tek sözlükte
// toplandı. Etiket ve renk dili Operasyon Yönetimi vardiyalar tablosundan geliyor
// (components/liveOperation/components/ActiveShiftsTable.js → STATUS_TAG_STYLE); üzerine
// puantaj durumları eklendi. Tek isim farkı: "Beklemede" → "Gelecek Vardiya".
export const SHIFT_STATUSES = {
    "Gelecek Vardiya": {background: "#DBEAFE", color: "#1e3a8a", border: "#93c5fd"},
    "Henüz Giriş Yapılmadı": {background: "#D85E5A", color: "#fff", border: "#D85E5A"},
    "Vardiyada - Müsait": {background: "#F5FEED", color: "#237804", border: "#b7eb8f"},
    "Vardiyada - Siparişte": {background: "#DED2E9", color: "#531dab", border: "#d3adf7"},
    "Vardiyada - Meşgul": {background: "#FFF1F0", color: "#a8071a", border: "#ffa39e"},
    "Vardiyada - Mola": {background: "#FFF7E6", color: "#ad6800", border: "#ffd591"},
    Tamamlandı: {background: "#D4FFA9", color: "#237804", border: "#b0e070"},
    "Tamamlandı (Giriş Yapılmadı)": {
        background: "#EBF0EB",
        color: "rgba(0, 0, 0, 0.65)",
        border: "#cdd6cd"
    },
    "İptal Edildi": {background: "#FFF1F0", color: "#a8071a", border: "#ffa39e"},
    "Onay Bekliyor": {background: "#F9F0FF", color: "#531dab", border: "#d3adf7"},
    "Paket Girişi Bekleniyor": {background: "#FFF7E6", color: "#ad6800", border: "#ffd591"},
    "İtiraz Sürecinde": {background: "#FFF1F0", color: "#cf1322", border: "#ffa39e"},
    Onaylandı: {background: "#F6FFED", color: "#237804", border: "#b7eb8f"}
};

// Akışın mantıksal sırası (vardiya yaşam döngüsü → puantaj adımları); durum filtresi bu
// sırayla listeler, alfabetik değil.
export const SHIFT_STATUS_ORDER = Object.keys(SHIFT_STATUSES);

// Yalnız dedike puantaj akışında görülen durumlar. Havuz ve dedike entegrasyon listeleri
// puantaj ucundan beslenmediği için bu durumlar o tiplerde hiç oluşmaz; durum filtresinde
// de gösterilmez.
export const REPORT_ONLY_SHIFT_STATUSES = [
    "Onay Bekliyor",
    "Paket Girişi Bekleniyor",
    "İtiraz Sürecinde",
    "Onaylandı"
];

// Sabit (düz dedike) vardiya listesinde tamamlanma bilgisi ayrı izlenmediği için "Tamamlandı"
// ve "Tamamlandı (Giriş Yapılmadı)" yalnız havuz ve sabit entegre tiplerinde anlamlı; sabit
// tipin durum filtresinde gizlenir.
export const DEDICATED_HIDDEN_SHIFT_STATUSES = ["Tamamlandı", "Tamamlandı (Giriş Yapılmadı)"];

// GEÇİCİ: havuz ve puantaj uçları durumu kod olarak döndürüyor, Operasyon Yönetimi ise hazır
// Türkçe etiket. Backend birleşik durum alanını göndermeye başlayınca bu eşleme silinecek.
// Not: `active_courier_entered` kuryenin anlık durumunu (müsait/meşgul/mola/siparişte)
// taşımadığı için en yakın karşılığa ("Vardiyada - Müsait") düşürülüyor.
const STATUS_LABEL_BY_CODE = {
    waiting: "Gelecek Vardiya",
    Beklemede: "Gelecek Vardiya",
    active_courier_entered: "Vardiyada - Müsait",
    active_courier_not_entered: "Henüz Giriş Yapılmadı",
    completed_courier_entered: "Tamamlandı (Giriş Yapıldı)",
    Tamamlandı: "Tamamlandı (Giriş Yapıldı)",
    completed_courier_not_entered: "Tamamlandı (Giriş Yapılmadı)",
    "Giriş Yapılmadan Tamamlandı": "Tamamlandı",
    cancelled: "İptal Edildi",
    waitingApprove: "Onay Bekliyor",
    needFillPackage: "Paket Girişi Bekleniyor",
    inReview: "İtiraz Sürecinde",
    approved: "Onaylandı"
};

/* Hem kodu hem hazır etiketi kabul eder; tanımadığı değeri null'a düşürür. */
export const toShiftStatusLabel = status => {
    if (!status) return null;
    if (SHIFT_STATUSES[status]) return status;
    return STATUS_LABEL_BY_CODE[status] || null;
};

// Puantaj listesi ucu durumu kod bekliyor. Yalnız puantaj karşılığı olan etiketler sunucu
// tarafında filtrelenebilir; kalanlar için "all" gönderilip filtre istemcide uygulanır.
const REPORT_STATUS_BY_LABEL = {
    "Onay Bekliyor": "waitingApprove",
    "Paket Girişi Bekleniyor": "needFillPackage",
    "İtiraz Sürecinde": "inReview",
    Onaylandı: "approved",
    "İptal Edildi": "cancelled"
};

export const toShiftReportStatusParam = label => REPORT_STATUS_BY_LABEL[label] || "all";

// Vardiya listesi (/shifts/list) durum alanını hazır Türkçe etiket olarak döndürüyor; puantaj
// aksiyon mantığı ise kod bekliyor. Puantaj karşılığı olmayan (yaşam döngüsü) etiketlerde null
// döner, böylece çağıran taraf "raporu olmayan vardiya" ayrımını yapabilir.
export const toShiftReportStatusCode = label => REPORT_STATUS_BY_LABEL[label] || null;
